import React from "react";
import "@layouts/index.scss";
import {Layout} from 'antd';
import LeftMenu from "@components/LeftMenu";
import RightMenu from "@components/RightMenu";
import MenuMobile from "@components/MenuMobile";
import BottomMobile from "@components/BottomMobile";

const {Content, Header, Sider, Footer} = Layout;

const MainLayout = ({children}) => {
  return (
    <React.Fragment>
      <Layout className="layout-wrapper">
        <Sider className="slider-left" width={280}><LeftMenu/></Sider>
        <Content>
          <Header className="header-mobile"><MenuMobile/></Header>
          <Layout>
            <Content className="content-menu-wrapper">
              {children}
            </Content>
            <Sider className="slider-right" width={350}><RightMenu/></Sider>
          </Layout>
          <Footer className="footer-mobile"><BottomMobile/></Footer>
        </Content>
      </Layout>
    </React.Fragment>
  );
};

export default MainLayout;
